function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M196.7 124.7l20.1 20L283.5 78l-66.7-66.7-20.1 20L229.4 64H0v27.9h229.5l-32.8 32.8zm86.8 66.9H54l32.8-32.8-20.1-20L0 205.5l66.7 66.7 20.1-20-32.7-32.7h229.4v-27.9z"
})));